export const convertPermission = (permissionList = []) => {
  const obj = {};

  permissionList.forEach(permission => {
    obj[permission.name] = true; // Use the `name` as the key and set its value to `true`
  });

  return obj;
};
